import { CSS, styled, StyleProps } from "../../styles"
import { flexCss } from "../../Flex"

const StyledContent = styled.div(
  (props: StyleProps): CSS => ({
    ...flexCss,
    position: `absolute`,
    zIndex: 2,
    top: `calc(100% + 12px)`,
    flexDirection: `column`,
    width: `100%`,
    maxHeight: 300,
    backgroundColor: props.theme.palette.white,
    borderRadius: 5,
    boxShadow: `0px 6px 20px hsla(0, 0%, 0%, .1)`,
    overflowY: `scroll`,
  })
)

export default StyledContent
